"use client";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger
} from "@cmp-src/primitives/tabs";
import { ISchedule, WorkplaceRequestElement } from "@gettactic/api";
import { useAuthenticated } from "@gettactic/hooks";
import { useState } from "react";
import { SelectTeams } from "@/features/teams/components/SelectTeams";
import { useTeamAttendanceFilters } from "@/features/teams/components/TeamSchedule/hooks/useTeamAttendanceFilters";
import { DashboardEventDetailsProps } from "./DashboardEventDetails";
import { UsersInOffice } from "./UsersInOffice";
import { WPRequestsList } from "./WPRequestsList";

export const AnyWorkplaceData = ({
  schedule,
  officeId,
  workplaceRequests,
  teamSchedule,
  onRequestClick,
  isOrgPrivacyEnabled
}: {
  schedule: ISchedule;
  officeId: string;
  workplaceRequests: WorkplaceRequestElement[];
  teamSchedule?: DashboardEventDetailsProps["teamSchedule"];
  onRequestClick?: (request: WorkplaceRequestElement) => void;
  isOrgPrivacyEnabled: boolean;
}) => {
  const [userCount, setUserCount] = useState<number>(0);

  const {
    userContext: { authenticatedUser }
  } = useAuthenticated();

  const {
    filters: dashboardFilters,
    isComponentLoading,
    setTeams
  } = useTeamAttendanceFilters({
    authenticatedUser,
    currentOffice: { id: officeId }
  });

  return (
    <Tabs
      defaultValue={
        workplaceRequests.length > 0 ? "workplaceRequests" : "users"
      }
    >
      <div className="flex items-center justify-between px-2.5 md:px-0">
        <TabsList className="font-bold">
          {!isOrgPrivacyEnabled && (
            <TabsTrigger className="py-1.5" value="users">
              In the office ({userCount})
            </TabsTrigger>
          )}
          {workplaceRequests.length > 0 && (
            <TabsTrigger value="workplaceRequests">
              Workplace Requests ({workplaceRequests.length})
            </TabsTrigger>
          )}
        </TabsList>
        {!isOrgPrivacyEnabled && (
          <div className="flex justify-end">
            <SelectTeams
              includeFavs={true}
              teams={dashboardFilters.teams}
              onChange={(teamIds: string[] | string) => {
                const teamIdsArray = Array.isArray(teamIds)
                  ? teamIds
                  : [teamIds];
                setTeams(teamIdsArray);
              }}
              variant="ghost"
              splitView={true}
              contentWidth="500px"
            />
          </div>
        )}
      </div>
      <TabsContent value="users">
        {teamSchedule ? (
          teamSchedule
        ) : isOrgPrivacyEnabled ? null : (
          <UsersInOffice
            officeId={officeId}
            onUserCountChange={setUserCount}
            isRoom={false}
          />
        )}
      </TabsContent>
      {workplaceRequests?.length > 0 && (
        <TabsContent value="workplaceRequests" className="md:px-0">
          <WPRequestsList
            schedule={schedule}
            workplaceRequests={workplaceRequests}
            onRequestClick={onRequestClick}
          />
        </TabsContent>
      )}
    </Tabs>
  );
};
